import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { hasFullLifecycle } from "@mizpah/shared";
import { useStudentAuth } from "./auth/StudentAuthContext.js";
import { api } from "./studentClient.js";
import StudentLoginPage from "./StudentLoginPage.js";

/** Gate the whole /portal area on student auth; render login until signed in. */
export default function StudentLayout() {
  const auth = useStudentAuth();
  const [courseId, setCourseId] = useState<string | null>(null);

  // Quizzes/homework are CNA-only; learn the student's course to gate the nav.
  useEffect(() => {
    if (auth.status !== "signedIn") return;
    api<{ student: { courseId: string } }>("/student/me")
      .then((d) => setCourseId(d.student.courseId))
      .catch(() => {});
  }, [auth.status]);

  if (auth.status === "loading") return <div className="login-wrap"><p className="sub">Loading...</p></div>;
  if (auth.status !== "signedIn") return <StudentLoginPage />;

  const showQuizzes = courseId != null && hasFullLifecycle(courseId);

  return (
    <div className="admin-shell">
      <header className="abar">
        <div className="brand"><img className="brandmark" src="/mizpah-logo.jpg" alt="Mizpah Center for Allied Health Education" /> Mizpah Student Portal</div>
        <nav className="anav">
          <NavLink to="/portal" end className={({ isActive }) => (isActive ? "active" : "")}>Dashboard</NavLink>
          {showQuizzes && <NavLink to="/portal/quizzes" className={({ isActive }) => (isActive ? "active" : "")}>Quizzes</NavLink>}
          {showQuizzes && <NavLink to="/portal/homework" className={({ isActive }) => (isActive ? "active" : "")}>Homework</NavLink>}
          {showQuizzes && <NavLink to="/portal/welcome" className={({ isActive }) => (isActive ? "active" : "")}>Welcome</NavLink>}
        </nav>
        <div className="aright">
          <button className="signout" onClick={auth.signOut}>Sign out</button>
        </div>
      </header>
      <main className="acontent"><Outlet /></main>
    </div>
  );
}
